import React from 'react';
import { ScoreCell } from 'components/scores';

const LeaderboardCellHole = ({ data }) => {
    return (
        <div className="leaderboard__cell leaderboard__cell--hole">
            <ScoreCell bemList={['default', 'has-border']}>{data.hole || '-'}</ScoreCell>
        </div>
    );
};

export default LeaderboardCellHole;
